import { LayoutData } from "../Structur/Aconlayout";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Tabs, Table } from "antd";
import { PendingComp } from "../Helper/ProgressComp";
import { useQuery } from "@tanstack/react-query";

export const JahrFeiertage = () => {
  const [dataSource, setDataSource] = useState();
  const [aktJahr, setAktJahr] = useState(new Date().getFullYear());
  const { aktSumsComponent, user, apiBaseUrl, logoutLogin } = LayoutData();
  const [tabsItems, setTabsItems] = useState(0);
  const [url1, setUrl1] = useState("");

  useEffect(() => {
    if (apiBaseUrl) {
      setUrl1(`${apiBaseUrl}api/getFeiertage?jahr=${aktJahr}`);
    }
  }, [apiBaseUrl, aktJahr]);

  const {
    isPending: isPending1,
    error: error1,
    data: feiertagetData,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) => {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return []; // Promise.resolve({});
      }
    },
  });

  useEffect(() => {
    if (feiertagetData && Array.isArray(feiertagetData)) {
      console.log("XXX feiertagetData", feiertagetData);
      const newData = feiertagetData.map((item, index) => ({
        ...item,
        key: index,
      }));
      setDataSource(newData);
    }
  }, [feiertagetData]);

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const tabs = [];
    for (let i = 0; i < 10; i++) {
      tabs.push({
        key: i,
        label: (
          <>
            <b>&nbsp;{currentYear + i}&nbsp;</b>
          </>
        ),
        jahr: currentYear + i,
        //children: <b>`Österreichische Feiertage ${currentYear + i}`</b>,
      });
    }
    setTabsItems(tabs);
    aktSumsComponent("Denke diese Info kann jeder brauchen");
  }, []);

  /*
  useEffect(() => {
    const fetchDaten = async () => {
      setInProgress(1);
      const url = `getFeiertage?jahr=${aktJahr}`;
      console.log("url",url);
      let list = await eventData("api", url);
      setInProgress(0);
      if (list) {
        setDataSource(list);
      }
    };
    fetchDaten();
  }, [aktJahr]);
*/
  const getColumnsFeiertage = () => {
    const columns = [
      {
        title: "Datum",
        dataIndex: "Datum",
        align: "right",
        render: (text, record) => (
          <>
            <big>{dayjs(record.Datum).format("ddd D.MM.YY")}</big>
          </>
        ),
      },
      {
        title: "Name",
        dataIndex: "Name",
        render: (text, record) => (
          <b>
            <big>{text}</big>
          </b>
        ),
      },
    ];
    return columns;
  };

  const onChangeTabs = (key, record) => {
    setAktJahr(tabsItems[key].jahr);
    //   console.log(key, tabsItems[key].label);
  };

  return (
    <>
      <div className="page">
        <center>
          <h2>Österreichische Feiertage {aktJahr}</h2>
        </center>
        <Tabs defaultActiveKey="1" items={tabsItems} onChange={onChangeTabs} />
        <Table
          //rowSelection={rowSelection}
          columns={getColumnsFeiertage()}
          dataSource={dataSource}
          pagination={false}
        />
      </div>
      <PendingComp isPending={isPending1} />
    </>
  );
};
